import { render, staticRenderFns } from "./CreatorDocs.vue?vue&type=template&id=489c0af8&"
import script from "./CreatorDocs.vue?vue&type=script&lang=js&"
export * from "./CreatorDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports